// @flow

import * as React from 'react';

type Props = {
  children: Array<React.Node>,
};

const StripeCluiTerminalContent = ({children}: Props): React.Node => {
  return (
    <div
      className="StripeCluiTerminalContent"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${children.length}, minmax(0, 100%))`,
        gridTemplateRows: 'repeat(1, 100%)',
      }}
    >
      {children.map((child, idx) => (
        <React.Fragment key={idx}>{child}</React.Fragment>
      ))}
    </div>
  );
};

export default StripeCluiTerminalContent;
